import React from 'react';
import './Testimonial.css';

const Testimonial = () => {
  const testimonials = [
    {
      id: 1,
      name: "Priya Sharma",
      company: "TechStart India",
      email: "priya@techstart.com",
      text: "LexPitch made our startup's legal setup incredibly smooth. From registration to compliance, everything was handled with precision and clarity. Highly recommended!",
      rating: 5
    },
    {
      id: 2,
      name: "Arjun Verma",
      company: "VentureLab",
      email: "arjun@venturelab.io",
      text: "Professional, efficient, and affordable. Didar Kaur's team understood our business needs perfectly and delivered solutions that actually work for startups.",
      rating: 5
    },
    {
      id: 3,
      name: "Neha Patel",
      company: "Digital Dreams Co.",
      email: "neha@digitaldeams.in",
      text: "The intellectual property guidance we received was invaluable. They protected our innovations and made the entire process transparent and stress-free.",
      rating: 5
    },
    {
      id: 4,
      name: "Rohit Singh",
      company: "CloudSync Systems",
      email: "rohit@cloudsync.com",
      text: "Exceptional service and quick turnaround. LexPitch's compliance advisory saved us from potential legal issues. They're true business partners, not just service providers.",
      rating: 5
    },
    {
      id: 5,
      name: "Anu Gupta",
      company: "EcoInnovate",
      email: "anu@ecoinnovate.org",
      text: "We appreciated the quick and prompt service. As a bootstrapped startup, LexPitch's straightforward approach and fair pricing were exactly what we needed.",
      rating: 5
    },
    {
      id: 6,
      name: "Vikram Joshi",
      company: "DataFlow Analytics",
      email: "vikram@dataflow.in",
      text: "Didar's expertise in contract negotiation proved invaluable for our partnerships. They ensured our interests were protected while maintaining great business relationships.",
      rating: 5
    }
  ];

  return (
    <section className="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <p className="testimonials-label">CLIENT SUCCESS STORIES</p>
          <h2 className="testimonials-title">Your success is our priority</h2>
          <p className="testimonials-subtitle">
            Real feedback from founders and entrepreneurs who've transformed their businesses with LexPitch guidance
          </p>
        </div>

        <div className="testimonials-content">
          <div className="testimonials-left">
            <div className="testimonials-text">
              <p className="main-quote">
                "We started LexPitch because we saw brilliant entrepreneurs being held back by overwhelming compliance. Our mission is to be the partner you can always count on."
              </p>
              <p className="sub-quote">
                "We combine technology with a team of experienced professionals to handle legal complexities for you. Your success is our priority because when you thrive, India thrives."
              </p>
              <div className="founder-info">
                <h4>Adv. Didar Kaur</h4>
                <p>Founder & Legal Advisor, LexPitch</p>
              </div>
            </div>
          </div>

          <div className="testimonials-right">
            {/* Marquee Column 1 - Scrolling Up */}
            <div className="testimonials-marquee marquee-up">
              <div className="marquee-content">
                {[...testimonials.slice(0, 3), ...testimonials.slice(0, 3)].map((testimonial, idx) => (
                  <div key={`up-${idx}`} className="testimonial-card">
                    <div className="card-header">
                      <div className="avatar">{testimonial.name.charAt(0)}</div>
                      <div className="card-info">
                        <h5>{testimonial.name}</h5>
                        <p>{testimonial.company}</p>
                      </div>
                    </div>
                    <p className="card-text">{testimonial.text}</p>
                    <div className="card-rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <span key={i} className="star">⭐</span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Marquee Column 2 - Scrolling Down */}
            <div className="testimonials-marquee marquee-down">
              <div className="marquee-content">
                {[...testimonials.slice(3, 6), ...testimonials.slice(3, 6)].map((testimonial, idx) => (
                  <div key={`down-${idx}`} className="testimonial-card">
                    <div className="card-header">
                      <div className="avatar">{testimonial.name.charAt(0)}</div>
                      <div className="card-info">
                        <h5>{testimonial.name}</h5>
                        <p>{testimonial.company}</p>
                      </div>
                    </div>
                    <p className="card-text">{testimonial.text}</p>
                    <div className="card-rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <span key={i} className="star">⭐</span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
